// extracted by mini-css-extract-plugin
module.exports = {"PowerSupport":"PowerSupport_PowerSupport__37ugM"};